import { MOCK_SUMMARY_CREDIT_EXTENSIONS } from "./fixtures";

const creditNoteMocksEnabled = () =>
  process.env.REACT_APP_USE_CREDIT_NOTE_MOCKS === "true";

function resolveMockExtension(summaryPayload) {
  const mode = String(summaryPayload.mode || "").toLowerCase();
  const hasDealer = summaryPayload.has_buyer_dealer === true;
  const isDirect = mode === "direct";
  const status = String(summaryPayload.status || "").toLowerCase();
  const isPlacedOrLater =
    status === "placed" ||
    status === "dealer_accepted" ||
    status === "accepted" ||
    status === "dispatched" ||
    status === "partially_delivered" ||
    status === "delivered";

  if (!isDirect && hasDealer && isPlacedOrLater) {
    return MOCK_SUMMARY_CREDIT_EXTENSIONS.dealer_placed;
  }
  if (isDirect) {
    return MOCK_SUMMARY_CREDIT_EXTENSIONS.direct;
  }
  return MOCK_SUMMARY_CREDIT_EXTENSIONS.dealer;
}

/**
 * When mocks are on, merge credit-note pricing fields into summary if API
 * has not added them yet.
 */
export function mergeSummaryCreditExtensions(summaryPayload) {
  if (!summaryPayload || !creditNoteMocksEnabled()) return summaryPayload;

  const hasCnFields =
    summaryPayload.dealer_price != null ||
    Number(summaryPayload.credit_adjustments_total) > 0;

  if (hasCnFields) return summaryPayload;

  const ext = resolveMockExtension(summaryPayload);

  return {
    ...summaryPayload,
    ...ext,
  };
}
